"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../basics/Button"));
var S = __importStar(require("./styles"));
var SkipToContentLink = function (_a) {
    var children = _a.children, _b = _a.skipTo, skipTo = _b === void 0 ? 'main' : _b, _c = _a.verticalOffset, verticalOffset = _c === void 0 ? '110px' : _c;
    var onClick = function (e) {
        e.preventDefault();
        var container = document.querySelector(skipTo);
        if (container) {
            container.tabIndex = -1;
            container.focus();
            setTimeout(function () { return container.removeAttribute('tabindex'); }, 1000);
        }
    };
    return (react_1.default.createElement(S.SkipToContentLink, { "data-component-name": "SkipToContentLink", "$verticalOffset": verticalOffset },
        react_1.default.createElement(Button_1.default, { onClick: onClick }, children)));
};
exports.default = SkipToContentLink;
